import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { AuthentService } from 'src/app/Services/authent.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() public CurrentLanguage = new EventEmitter();

  resourceDefinition;
  Language;
  user;

  constructor(
    private shareData: SharingDataService,
    public authService: AuthentService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe(data => this.Language = data);
    this.shareData.currentUser.subscribe(data => this.user = data);
  }

  setLanguage(language) {
    this.CurrentLanguage.emit(language);
  }

  route(route: string) {
    this.router.navigate([route]);
  }

  logout(){
    this.authService.logout();
    this.router.navigate([""]);

  }
}